import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/school/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * @param route
   * @returns {AxiosPromise}
   */
  getSeasonsWithRelations() {
    return conduit.get('seasons/with-relations');
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonById(seasonId) {
    return conduit.get(`seasons/${seasonId}`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonWithRelationsBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/with-relations`);
  },

  /**
   * @param skiSchoolSeason
   * @returns {AxiosPromise}
   */
  createSeason(skiSchoolSeason) {
    return conduit.post('seasons/add', {
      skiSchoolSeason,
    });
  },

  /**
   * @param skiSchoolSeason
   * @returns {AxiosPromise}
   */
  saveSeason(skiSchoolSeason) {
    return conduit.put(`seasons/${skiSchoolSeason.id}/update`, {
      skiSchoolSeason,
    });
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPersonCategoriesById(seasonId) {
    return conduit.get(`person-categories/season/${seasonId}`);
  },

  /**
   * @param skiSchoolPersonCategory
   * @returns {AxiosPromise}
   */
  createPersonCategory(skiSchoolPersonCategory) {
    return conduit.post('person-categories/add', {
      skiSchoolPersonCategory,
    });
  },

  /**
   * @param skiSchoolPersonCategory
   * @returns {AxiosPromise}
   */
  savePersonCategory(skiSchoolPersonCategory) {
    return conduit.put(`person-categories/${skiSchoolPersonCategory.id}/update`, {
      skiSchoolPersonCategory,
    });
  },

  /**
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  deletePersonCategory(personCategoryId) {
    return conduit.delete(`person-categories/${personCategoryId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getLevelsById(seasonId) {
    return conduit.get(`levels/season/${seasonId}`);
  },

  /**
   * @param skiSchoolSeasonLevel
   * @returns {AxiosPromise}
   */
  createLevel(skiSchoolSeasonLevel) {
    return conduit.post('levels/add', {
      skiSchoolSeasonLevel,
    });
  },

  /**
   * @param skiSchoolSeasonLevel
   * @returns {AxiosPromise}
   */
  saveLevel(skiSchoolSeasonLevel) {
    return conduit.put(`levels/${skiSchoolSeasonLevel.id}/update`, {
      skiSchoolSeasonLevel,
    });
  },

  /**
   * @param levelId
   * @returns {AxiosPromise}
   */
  deleteLevel(levelId) {
    return conduit.delete(`levels/${levelId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getAreasBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/areas`);
  },

  /**
   * @param seasonId
   * @param skiAreaId
   * @returns {AxiosPromise}
   */
  saveAreaOnSeason(seasonId, skiAreaId) {
    return conduit.post(
      `seasons/${seasonId}/areas/${skiAreaId}/add`,
      {},
    );
  },

  /**
   * @param seasonId
   * @param skiAreaId
   * @returns {AxiosPromise}
   */
  deleteAreaOnSeason(seasonId, skiAreaId) {
    return conduit.delete(`seasons/${seasonId}/areas/${skiAreaId}/delete`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getSalesTypes() {
    return conduit.get('sales-types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getSkiSchoolLessonTypes() {
    return conduit.get('lesson-types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getSkiSchoolSkiTypes() {
    return conduit.get('ski-types');
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPricesBySeasonId(seasonId) {
    return conduit.get(`prices/season/${seasonId}`);
  },

  /**
   * @param skiSchoolPrice
   * @returns {AxiosPromise}
   */
  createPrice(skiSchoolPrice) {
    return conduit.post('prices/add', {
      skiSchoolPrice,
    });
  },

  /**
   * @param skiSchoolPrice
   * @returns {AxiosPromise}
   */
  savePrice(skiSchoolPrice) {
    return conduit.put(`prices/${skiSchoolPrice.id}/update`, {
      skiSchoolPrice,
    });
  },

  /**
   * @param priceId
   * @returns {AxiosPromise}
   */
  deletePrice(priceId) {
    return conduit.delete(`prices/${priceId}/delete`);
  },

  /**
   * @param priceId
   * @param weekdayNumber
   * @returns {AxiosPromise}
   */
  saveStartDayOnPrice(priceId, weekdayNumber) {
    return conduit.post(
      `prices/${priceId}/start-days/${weekdayNumber}/add`,
      {},
    );
  },

  /**
   * @param priceId
   * @param weekdayNumber
   * @returns {AxiosPromise}
   */
  deleteStartDayOnPrice(priceId, weekdayNumber) {
    return conduit.delete(`prices/${priceId}/start-days/${weekdayNumber}/delete`);
  },

  /**
   * @param priceId
   * @param skiSchoolPriceCombination
   * @returns {AxiosPromise}
   */
  savePriceCombination(priceId, skiSchoolPriceCombination) {
    return conduit.post(`prices/${priceId}/combinations/add`, {
      skiSchoolPriceCombination,
    });
  },

  /**
   * @param priceId
   * @param priceCombinationId
   * @returns {AxiosPromise}
   */
  deletePriceCombination(priceId, priceCombinationId) {
    return conduit.delete(`prices/${priceId}/combinations/${priceCombinationId}/delete`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-school-service.js